import { Component, OnInit, ElementRef, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import echarts from 'echarts';
import { formatNumber } from '../../../../shared/utils/common';

@Component({
  selector: 'app-active-days',
  templateUrl: './active-days.component.html',
  styleUrls: ['./active-days.component.less'],
})
export class ActiveDaysComponent implements OnInit, OnChanges {
  constructor(private el: ElementRef) {}

static NAME = 'icc-msg-social-fans-active';

  // 图谱实例
  chartIns: any;

  // 展示数据
  activeDaysList: Array<string> = [];
  countList: Array<number> = [];

  // 数据源
  @Input() data: Array<{
    item: string; // 活跃天数
    value: number; // 粉丝数量
  }>;

  // 排名列表
  rankList: Array<{
    name: string; // 活跃天数
    value: string; // 粉丝数
    ratio: string; // 占比
  }>;

  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };

  ngOnInit() {
    window.addEventListener('resize', this.resizeCharts);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data instanceof Array) {
      this.activeDaysList = [];
      this.countList = [];
      this.data.forEach(item => {
        this.activeDaysList.push(item.item);
        this.countList.push(item.value);
      });
      /* this.formatPieData(this.data); */
      this.rankList = [];
      this.getRank();
      setTimeout(() => {
        this.createLineChart('chart-el');
      }, 100);
    }
  }

  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }

  // 数据处理
  formatPieData(data) {
    const result = [];
    let sub = 0;
    data.forEach((item: any) => {
      sub = sub + item.value;
    });
    data.forEach((item: any) => {
      const temp: any = {};
      temp.name = item.item;
      temp.value = formatNumber(item.value);
      const radioBefore =item.value===0 ? 0: Number((item.value / sub).toFixed(2)) * 100;
      temp.ratio = radioBefore.toFixed(0) + '%';
      result.push(temp);
    });
    return result;
  }

  // 获取粉丝数量前五名
  getRank() {
    // 深拷贝数据
    let data2 = JSON.parse(JSON.stringify(this.data));
    let tempData = data2.sort((a, b) => b.value - a.value);
    this.rankList = this.formatPieData(tempData).splice(0, 5);
  }

  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    const axisLabel: any = {
      textStyle: {
        color: '#B9C0D6',
      },
      formatter: '{value} ',
      margin: 20,
    };
    if (this.data.length >= 10) {
      axisLabel.margin = 10;
      axisLabel.interval = 0;
      axisLabel.rotate = 0;
    }
    this.chartIns.setOption({
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.6)',
      },
      legend: {
        show: false,
      },
      grid: {
        x: '8%',
        width: '82%',
        y: '12%',
        top: '20%',
      },
      xAxis: [
        {
          data: this.activeDaysList,
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel,
        },
      ],
      yAxis: [
        {
          name: '单位:个',
          nameTextStyle: {
            padding: [3, 4, 5, 6],
            color: '#B9C0D6',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#B9C0D6',
            },
            formatter: '{value} ',
          },
        },
        {
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
        },
      ],
      series: [
        {
          name: '粉丝数',
          type: 'bar',
          symbolSize: 1,
          barWidth: 40, // 柱体宽度
          itemStyle: {
            normal: {
              color: 'rgb(0,206,158)',
            },
          },
          data: this.countList,
        },
      ],
    });
  }
}
